import { api } from './api';

/** Cartões por página na lista de Destaques: 5 fileiras de 3 (DEX-10). */
export const DESTAQUES_POR_PAGINA = 15;

/** Realização que deu o selo, como gravada no fechamento do ciclo. */
export interface RealizacaoDoSelo {
  total?: number;
  titulo?: string;
  descricao?: string;
  taskId?: string;
}

/** Um funci da lista de Destaques: os tipos de destaque que conquistou no ciclo (`find/destaques_do_prefixo`). */
export interface DestaqueDoFunci {
  _id: string;
  matricula: string;
  nome: string;
  nome_guerra?: string;
  funcao?: string;
  diretoria?: string;
  /** Prefixo e dependência do funci; a lista é do prefixo de quem acessa, então são os dele também. */
  prefixo?: number | string;
  nome_dependencia?: string;
  galeria: boolean;
  /** Comportamento do Destaque da Cultura (`colaboracao`, `foco`…); sem Cultura, ausente. */
  cultura?: string | null;
  realizacao?: RealizacaoDoSelo | null;
  qtdTipos: number;
  avatar?: Record<string, unknown>;
  avatar_type?: number;
  image?: string;
  /** Só no perfil: cadastro e indicador da tarefa da realização (`bb_task__c`). */
  cadastro?: number;
  indicador?: string;
}

interface PedidoDaLista {
  cycleId: string;
  /** Página a partir de 1. */
  pagina: number;
  busca?: string;
}

/** Total do `content-range` ("items 9-9/122" → 122); sem cabeçalho, o número de itens. */
function totalDaResposta(contentRange: string | undefined, quantidade: number) {
  const total = Number(contentRange?.split('/')[1]);
  return Number.isFinite(total) ? total : quantidade;
}

/** DST-01, DST-08, DST-09: uma página da lista do prefixo de quem acessa, com o total do ciclo (ou da busca). */
export async function getDestaquesDoPrefixo({ cycleId, pagina, busca }: PedidoDaLista) {
  const termo = busca?.trim();
  const inicio = (pagina - 1) * DESTAQUES_POR_PAGINA;

  const { data, headers } = await api.post(
    'find/destaques_do_prefixo',
    { cycleId, ...(termo ? { search: termo } : {}) },
    { headers: { Range: `items=${inicio}-${DESTAQUES_POR_PAGINA}` } },
  );

  const itens: DestaqueDoFunci[] = Array.isArray(data) ? data : [];
  return { itens, total: Array.isArray(data) ? totalDaResposta(headers?.['content-range'], itens.length) : 0 };
}

/** DST-21: o funci do perfil, no prefixo de quem acessa; fora do prefixo ou sem destaque, `undefined`. */
export async function getDestaqueDoFunci(cycleId: string, funci: string): Promise<DestaqueDoFunci | undefined> {
  const { data } = await api.post('find/destaques_do_prefixo', { cycleId, funci });
  return Array.isArray(data) ? data[0] : undefined;
}
